import { SvgIconComponent } from '@mui/icons-material';
import PointOfSaleRounded from '@mui/icons-material/PointOfSaleRounded';
import FolderRounded from '@mui/icons-material/FolderRounded';
import Inventory2Rounded from '@mui/icons-material/Inventory2Rounded';
import AccountBalanceWalletRounded from '@mui/icons-material/AccountBalanceWalletRounded';
import AccountBalanceRounded from '@mui/icons-material/AccountBalanceRounded';
import HandshakeRounded from '@mui/icons-material/HandshakeRounded';
import LocalShippingRounded from '@mui/icons-material/LocalShippingRounded';
import PeopleRounded from '@mui/icons-material/PeopleRounded';
import SchemaRounded from '@mui/icons-material/SchemaRounded';
import StackedLineChartRounded from '@mui/icons-material/StackedLineChartRounded';
import InsightsRounded from '@mui/icons-material/InsightsRounded';
import InputRounded from '@mui/icons-material/InputRounded';
import WebhookRounded from '@mui/icons-material/WebhookRounded';
import WorkspacesRounded from '@mui/icons-material/WorkspacesRounded';
import LibraryBooksRounded from '@mui/icons-material/LibraryBooksRounded';
import RequestQuoteRounded from '@mui/icons-material/RequestQuoteRounded';
import DescriptionRounded from '@mui/icons-material/DescriptionRounded';
import SyncAltRounded from '@mui/icons-material/SyncAltRounded';
import CurrencyExchangeRounded from '@mui/icons-material/CurrencyExchangeRounded';
import MoveToInboxRounded from '@mui/icons-material/MoveToInboxRounded';
import ReceiptLongRounded from '@mui/icons-material/ReceiptLongRounded';
import CloudDownloadRounded from '@mui/icons-material/CloudDownloadRounded';
import SettingsRounded from '@mui/icons-material/SettingsRounded';
import BusinessRounded from '@mui/icons-material/BusinessRounded';
import CloudDoneRounded from '@mui/icons-material/CloudDoneRounded';
import CloudOffRounded from '@mui/icons-material/CloudOffRounded';
import CloudSyncRounded from '@mui/icons-material/CloudSyncRounded';
import LogoutRounded from '@mui/icons-material/LogoutRounded';
import BuildRounded from '@mui/icons-material/BuildRounded';
import HomeRounded from '@mui/icons-material/HomeRounded';
import InstallDesktopRounded from '@mui/icons-material/InstallDesktopRounded';

// Registro de ícones da sidebar/submenu — mapeia as chaves de string já
// usadas em routes/index.tsx e MenuLateral.tsx para componentes
// `@mui/icons-material/*Rounded` (guia seções 21-22), substituindo os dois
// sistemas de fonte de ligadura (Material Icons / Material Symbols) usados
// antes. As chaves em si não mudam — só o que elas resolvem.
export const iconRegistry = {
  point_of_sale: PointOfSaleRounded,
  folder: FolderRounded,
  'symbols:pallet': Inventory2Rounded,
  'symbols:payments': AccountBalanceWalletRounded,
  account_balance: AccountBalanceRounded,
  handshake: HandshakeRounded,
  local_shipping: LocalShippingRounded,
  people: PeopleRounded,
  schema: SchemaRounded,
  stacked_line_chart: StackedLineChartRounded,
  insights: InsightsRounded,
  input: InputRounded,
  inventory2: Inventory2Rounded,
  webhook: WebhookRounded,
  workspaces: WorkspacesRounded,
  library_books: LibraryBooksRounded,
  account_balance_wallet: AccountBalanceWalletRounded,
  request_quote: RequestQuoteRounded,
  description: DescriptionRounded,
  syncAlt: SyncAltRounded,
  currency_exchange: CurrencyExchangeRounded,
  move_to_inbox: MoveToInboxRounded,
  receiptLong: ReceiptLongRounded,
  cloudDownload: CloudDownloadRounded,
  settings: SettingsRounded,
  business: BusinessRounded,
  // Status de conexão no painel de Configurações (ver MenuLateral.tsx).
  cloudDone: CloudDoneRounded,
  cloudOff: CloudOffRounded,
  cloudSync: CloudSyncRounded,
  // "Instalar SIAC no computador" (ver shared/pwa/instalacao.ts).
  installDesktop: InstallDesktopRounded,
  exit_to_app: LogoutRounded,
  build: BuildRounded,
  home: HomeRounded,
} satisfies Record<string, SvgIconComponent>;

export type ModuleIconKey = keyof typeof iconRegistry;
